<div class="sa-page">
  <header class="sa-header-bar">
    <div class="sa-header-title">{{ 'Executive Overview' | translate }}</div>
    <div class="sa-header-filters">
      <button class="sa-filter sa-filter--range" type="button">
        <span class="sa-filter-icon sa-filter-icon--calendar"></span>
        <span class="sa-filter-label">{{ 'Last 30 Days' | translate }}</span>
      </button>
      <button class="sa-filter" type="button">
        <span class="sa-filter-icon sa-filter-icon--doc-type"></span>
        <span class="sa-filter-label">{{ 'Document Type' | translate }}</span>
      </button>
      <button class="sa-filter" type="button">
        <span class="sa-filter-icon sa-filter-icon--status"></span>
        <span class="sa-filter-label">{{ 'Status' | translate }}</span>
      </button>
    </div>
  </header>

  <div class="spend-analytics-toggle" role="tablist" [attr.aria-label]="'Spend tabs' | translate">
    <button
      class="toggle-pill"
      type="button"
      role="tab"
      (click)="selectTab('analytics')"
      [class.toggle-pill--active]="selectedTab === 'analytics'">
      <span>{{ 'Spend Analytics' | translate }}</span>
    </button>

    <button
      class="toggle-pill"
      type="button"
      role="tab"
      (click)="selectTab('intelligence')"
      [class.toggle-pill--active]="selectedTab === 'intelligence'">
      <span>{{ 'Spend Intelligence' | translate }}</span>
    </button>
  </div>

  <div *ngIf="selectedTab === 'analytics'" class="executive-overview">
    <div class="eo-main">
      <header class="eo-header">
        <h1 class="eo-title">{{ 'Spend Overview Dashboard' | translate }}</h1>
        <p class="eo-subtitle">{{ 'Insights tailored for CFO performance.' | translate }}</p>
      </header>

      <section class="eo-kpi-row">
        <article class="eo-card">
          <div class="eo-card-icon"></div>
          <div class="eo-card-body">
            <div class="eo-card-label">{{ 'Total Spend (YTD)' | translate }}</div>
            <div class="eo-card-value">{{ '$12.8M' | translate }}</div>
            <div class="eo-card-trend eo-card-trend--up">
              <span class="eo-card-trend-icon"></span>
              <span>{{ '5.2% increase vs last period' | translate }}</span>
            </div>
          </div>
        </article>

        <article class="eo-card">
          <div class="eo-card-icon"></div>
          <div class="eo-card-body">
            <div class="eo-card-label">{{ 'Savings Identified' | translate }}</div>
            <div class="eo-card-value">{{ '$1.4M' | translate }}</div>
            <div class="eo-card-trend eo-card-trend--up">
              <span class="eo-card-trend-icon"></span>
              <span>{{ '12.8% increase vs last period' | translate }}</span>
            </div>
          </div>
        </article>

        <article class="eo-card">
          <div class="eo-card-icon"></div>
          <div class="eo-card-body">
            <div class="eo-card-label">{{ 'Budget Variance' | translate }}</div>
            <div class="eo-card-value">-2.1%</div>
            <div class="eo-card-trend eo-card-trend--down">
              <span class="eo-card-trend-icon eo-card-trend-icon--down"></span>
              <span>{{ '0.5% decrease vs last period' | translate }}</span>
            </div>
          </div>
        </article>
      </section>

      <section class="eo-row">
        <article class="eo-panel">
          <header class="eo-panel-header">
            <h2 class="eo-panel-title">{{ 'Spend Trends Over Time' | translate }}</h2>
          </header>
          <div class="eo-panel-body eo-panel-body--chart">
            <div class="eo-line-chart">
              <canvas
                baseChart
                [data]="spendTrendsData"
                [options]="spendTrendsOptions"
                [type]="'line'">
              </canvas>
            </div>
          </div>
        </article>

        <article class="eo-panel">
          <header class="eo-panel-header">
            <h2 class="eo-panel-title">{{ 'Spend by Category' | translate }}</h2>
          </header>
          <div class="eo-panel-body">
            <div class="eo-donut-chart">
              <div class="eo-donut"></div>
            </div>
            <div class="eo-donut-legend">
              <span class="eo-legend-swatch eo-legend-swatch--cat1"></span> {{ 'IT &amp; Software' | translate }}
              <span class="eo-legend-swatch eo-legend-swatch--cat2"></span> {{ 'Logistics' | translate }}
              <span class="eo-legend-swatch eo-legend-swatch--cat3"></span> {{ 'Office' | translate }}
              <span class="eo-legend-swatch eo-legend-swatch--cat4"></span> {{ 'Consulting' | translate }}
              <span class="eo-legend-swatch eo-legend-swatch--cat5"></span> {{ 'Utilities' | translate }}
              <span class="eo-legend-swatch eo-legend-swatch--cat6"></span> {{ 'Other' | translate }}
            </div>
          </div>
        </article>
      </section>

      <section class="eo-row eo-row--wide">
        <header class="eo-section-header">
          <h2>{{ 'Top Suppliers' | translate }}</h2>
        </header>
        <article class="eo-panel">
          <div class="eo-panel-body eo-panel-body--table">
            <div class="eo-table">
              <div class="eo-table-header">
                <div class="eo-th eo-th--supplier">{{ 'Supplier' | translate }}</div>
                <div class="eo-th eo-th--spend">{{ 'Spend' | translate }}</div>
                <div class="eo-th eo-th--percent">{{ '% of Total' | translate }}</div>
                <div class="eo-th eo-th--risk">{{ 'Risk Rating' | translate }}</div>
              </div>
              <div class="eo-table-row">
                <div class="eo-td eo-td--supplier">{{ 'Tech Solutions Inc.' | translate }}</div>
                <div class="eo-td eo-td--spend">{{ '$2.1M' | translate }}</div>
                <div class="eo-td eo-td--percent">16.4%</div>
                <div class="eo-td eo-td--risk">
                  <span class="eo-tag eo-tag--low">{{ 'Low' | translate }}</span>
                </div>
              </div>
              <div class="eo-table-row eo-table-row--alt">
                <div class="eo-td eo-td--supplier">{{ 'Global Logistics Corp.' | translate }}</div>
                <div class="eo-td eo-td--spend">{{ '$1.8M' | translate }}</div>
                <div class="eo-td eo-td--percent">14.1%</div>
                <div class="eo-td eo-td--risk">
                  <span class="eo-tag eo-tag--medium">{{ 'Medium' | translate }}</span>
                </div>
              </div>
              <div class="eo-table-row">
                <div class="eo-td eo-td--supplier">{{ 'Office Essentials Co.' | translate }}</div>
                <div class="eo-td eo-td--spend">{{ '$1.5M' | translate }}</div>
                <div class="eo-td eo-td--percent">11.7%</div>
                <div class="eo-td eo-td--risk">
                  <span class="eo-tag eo-tag--low">{{ 'Low' | translate }}</span>
                </div>
              </div>
              <div class="eo-table-row eo-table-row--alt">
                <div class="eo-td eo-td--supplier">{{ 'Consulting Partners Ltd.' | translate }}</div>
                <div class="eo-td eo-td--spend">{{ '$1.3M' | translate }}</div>
                <div class="eo-td eo-td--percent">10.1%</div>
                <div class="eo-td eo-td--risk">
                  <span class="eo-tag eo-tag--medium">{{ 'Medium' | translate }}</span>
                </div>
              </div>
              <div class="eo-table-row">
                <div class="eo-td eo-td--supplier">{{ 'Cloud Services Pro' | translate }}</div>
                <div class="eo-td eo-td--spend">{{ '$0.9M' | translate }}</div>
                <div class="eo-td eo-td--percent">7.0%</div>
                <div class="eo-td eo-td--risk">
                  <span class="eo-tag eo-tag--high">{{ 'High' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section class="eo-row eo-row--distribution">
        <header class="eo-section-header">
          <h2>{{ 'Spend Distribution' | translate }}</h2>
        </header>
        <div class="eo-distribution-row">
          <article class="eo-panel">
            <header class="eo-panel-header">
              <h3 class="eo-panel-title">{{ 'By Region' | translate }}</h3>
            </header>
            <div class="eo-panel-body">
              <div class="eo-bar-chart eo-bar-chart--vertical">
                <div class="eo-bar-ylabels">
                  <span>3,500,000</span>
                  <span>2,625,000</span>
                  <span>1,750,000</span>
                  <span>875,000</span>
                  <span>0</span>
                </div>
                <div class="eo-bar-plot">
                  <div class="eo-bar-gridlines"></div>
                  <div class="eo-bars">
                    <div class="eo-bar eo-bar--region1"></div>
                    <div class="eo-bar eo-bar--region2"></div>
                    <div class="eo-bar eo-bar--region3"></div>
                    <div class="eo-bar eo-bar--region4"></div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <article class="eo-panel">
            <header class="eo-panel-header">
              <h3 class="eo-panel-title">{{ 'By Business Unit' | translate }}</h3>
            </header>
            <div class="eo-panel-body">
              <div class="eo-bar-chart eo-bar-chart--vertical">
                <div class="eo-bar-ylabels">
                  <span>2,900,000</span>
                  <span>2,175,000</span>
                  <span>1,450,000</span>
                  <span>725,000</span>
                  <span>0</span>
                </div>
                <div class="eo-bar-plot">
                  <div class="eo-bar-gridlines"></div>
                  <div class="eo-bars">
                    <div class="eo-bar eo-bar--bu1"></div>
                    <div class="eo-bar eo-bar--bu2"></div>
                    <div class="eo-bar eo-bar--bu3"></div>
                    <div class="eo-bar eo-bar--bu4"></div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <article class="eo-panel">
            <header class="eo-panel-header">
              <h3 class="eo-panel-title">{{ 'By Cost Center' | translate }}</h3>
            </header>
            <div class="eo-panel-body">
              <div class="eo-bar-chart eo-bar-chart--vertical">
                <div class="eo-bar-ylabels">
                  <span>1,500,000</span>
                  <span>1,125,000</span>
                  <span>750,000</span>
                  <span>375,000</span>
                  <span>0</span>
                </div>
                <div class="eo-bar-plot">
                  <div class="eo-bar-gridlines"></div>
                  <div class="eo-bars">
                    <div class="eo-bar eo-bar--cc1"></div>
                    <div class="eo-bar eo-bar--cc2"></div>
                    <div class="eo-bar eo-bar--cc3"></div>
                    <div class="eo-bar eo-bar--cc4"></div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>

    <aside class="eo-side">
      <section class="eo-panel">
        <header class="eo-panel-header">
          <h3 class="eo-panel-title">{{ 'Switch Role View' | translate }}</h3>
        </header>
        <div class="eo-panel-body eo-role-switch">
          <button class="eo-role-button eo-role-button--active" type="button">{{ 'CFO' | translate }}</button>
          <button class="eo-role-button" type="button">{{ 'CPO' | translate }}</button>
          <button class="eo-role-button" type="button">{{ 'CTO' | translate }}</button>
          <button class="eo-role-button" type="button">{{ 'Category Manager' | translate }}</button>
        </div>
      </section>

      <section class="eo-panel">
        <header class="eo-panel-header">
          <h3 class="eo-panel-title">{{ 'AI-Powered Insights' | translate }}</h3>
        </header>
        <div class="eo-panel-body eo-insights">
          <div class="eo-insight">
            <div class="eo-insight-icon eo-insight-icon--alert"></div>
            <div class="eo-insight-content">
              <h4>{{ 'High Spend in Uncategorized' | translate }}</h4>
              <p>{{ 'Address $250K in unclassified spend this quarter.' | translate }}</p>
              <span>{{ 'Est. Impact: $50K' | translate }}</span>
            </div>
          </div>
          <div class="eo-insight">
            <div class="eo-insight-icon eo-insight-icon--idea"></div>
            <div class="eo-insight-content">
              <h4>{{ 'Early Payment Discounts' | translate }}</h4>
              <p>{{ 'Opportunity to save $120K by optimizing payment terms.' | translate }}</p>
              <span>{{ 'Est. Impact: $120K' | translate }}</span>
            </div>
          </div>
          <div class="eo-insight">
            <div class="eo-insight-icon eo-insight-icon--target"></div>
            <div class="eo-insight-content">
              <h4>{{ 'Budget Overrun Alert' | translate }}</h4>
              <p>{{ 'Marketing spend 15% over budget in Q3.' | translate }}</p>
              <span>{{ 'Action Required' | translate }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="eo-panel">
        <header class="eo-panel-header">
          <h3 class="eo-panel-title">{{ 'Risk Concentration' | translate }}</h3>
        </header>
        <div class="eo-panel-body eo-insights">
          <div class="eo-insight">
            <div class="eo-insight-icon eo-insight-icon--risk-high"></div>
            <div class="eo-insight-content">
              <h4>{{ 'Supply Chain Vulnerability' | translate }}</h4>
              <p>{{ 'Over-reliance on single-source suppliers for critical components.' | translate }}</p>
              <span class="eo-tag eo-tag--high">{{ 'High Risk' | translate }}</span>
            </div>
          </div>
          <div class="eo-insight">
            <div class="eo-insight-icon eo-insight-icon--info"></div>
            <div class="eo-insight-content">
              <h4>{{ 'Geopolitical Exposure' | translate }}</h4>
              <p>{{ 'Significant spend in regions with high political instability.' | translate }}</p>
              <span class="eo-tag eo-tag--medium-outline">{{ 'Medium Risk' | translate }}</span>
            </div>
          </div>
        </div>
      </section>
    </aside>
  </div>

  <div *ngIf="selectedTab === 'intelligence'" class="intelligence-overview">
    <app-spend-intelligence></app-spend-intelligence>
  </div>
</div>